import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/createClass";
import { TokenType as tt } from "./parser/tokenizer/types";

var NameManager =
/*#__PURE__*/
function () {
  _createClass(NameManager, [{
    key: "__init",
    value: function __init() {
      this.usedNames = new Set();
    }
  }]);

  function NameManager(tokens) {
    _classCallCheck(this, NameManager);

    ;
    this.tokens = tokens;

    NameManager.prototype.__init.call(this);
  }

  _createClass(NameManager, [{
    key: "preprocessNames",
    value: function preprocessNames() {
      for (var i = 0; i < this.tokens.tokens.length; i++) {
        if (this.tokens.matches1AtIndex(i, tt.name)) {
          this.usedNames.add(this.tokens.identifierNameAtIndex(i));
        }
      }
    }
  }, {
    key: "claimFreeName",
    value: function claimFreeName(name) {
      var newName = this.findFreeName(name);
      this.usedNames.add(newName);
      return newName;
    }
  }, {
    key: "findFreeName",
    value: function findFreeName(name) {
      if (!this.usedNames.has(name)) {
        return name;
      }

      var suffixNum = 2;

      while (this.usedNames.has(name + suffixNum)) {
        suffixNum++;
      }

      return name + suffixNum;
    }
  }]);

  return NameManager;
}();

export { NameManager as default };